/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';
import reloadIcon from 'trustar/img/reload.svg';
import nextIcon from 'trustar/img/next.svg';
import prevIcon from 'trustar/img/prev.svg';
import filterIcon from 'trustar/img/funnel.svg';
import searchIcon from 'trustar/img/magnifier.svg';
import calendarIcon from 'trustar/img/calendar-full.svg';
import downloadIcon from 'trustar/img/download.svg';
import floppyIcon from 'trustar/img/floppy-disk.svg';
import cogIcon from 'trustar/img/cog.svg';
import redoIcon from 'trustar/img/redo.svg';
import undoIcon from 'trustar/img/undo.svg';

import adminAddonBonus from './admean.png';
import s from './Icons.styl';

const cx = classnames.bind(s);

/**
 * NOTE: svg markup was originally exported from Sketch but has since been
 * modified here
 */
type
IconProps = {
  color?: string,
};
export const ExploreIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-328.000000, -25.000000)'>
      <path
        d='M342.755,38.043 L341.932,36.749 L342.755,35.456 L348.706,36.749 L342.755,38.043 Z M341.021,44.47 L341.923,40.315 L343.893,41.568 C343.974,41.62 344.065,41.646 344.156,41.646 C344.282,41.646 344.408,41.597 344.502,41.502 C344.664,41.34 344.692,41.086 344.569,40.893 L343.316,38.924 L347.469,38.021 C346.927,41.301 344.3,43.927 341.021,44.47 Z M339.75,45.705 L338.456,39.755 L339.75,38.932 L341.043,39.755 L339.75,45.705 Z M332.029,38.021 L336.184,38.924 L334.93,40.893 C334.807,41.086 334.835,41.34 334.997,41.502 C335.16,41.664 335.414,41.69 335.607,41.568 L337.576,40.315 L338.479,44.47 C335.198,43.927 332.572,41.301 332.029,38.021 Z M330.794,36.749 L336.744,35.456 L337.567,36.749 L336.744,38.043 L330.794,36.749 Z M338.479,29.029 L337.576,33.184 L335.607,31.93 C335.414,31.808 335.16,31.834 334.997,31.997 C334.835,32.159 334.807,32.412 334.93,32.606 L336.184,34.575 L332.029,35.479 C332.572,32.198 335.198,29.572 338.479,29.029 Z M339.75,27.793 L341.043,33.744 L339.75,34.566 L338.456,33.744 L339.75,27.793 Z M340.939,37.013 L342.56,39.56 L340.013,37.939 C339.932,37.887 339.841,37.862 339.75,37.862 C339.658,37.862 339.567,37.887 339.486,37.939 L336.939,39.56 L338.561,37.013 C338.662,36.852 338.662,36.647 338.561,36.486 L336.939,33.939 L339.486,35.561 C339.647,35.663 339.852,35.663 340.013,35.561 L342.56,33.939 L340.939,36.486 C340.837,36.647 340.837,36.852 340.939,37.013 Z M347.469,35.479 L343.316,34.575 L344.569,32.606 C344.692,32.412 344.664,32.159 344.502,31.997 C344.338,31.834 344.087,31.808 343.893,31.93 L341.923,33.184 L341.021,29.029 C344.3,29.572 346.927,32.198 347.469,35.479 Z M351.114,36.271 L348.483,35.699 C348.004,31.645 344.854,28.495 340.8,28.016 L340.228,25.385 C340.179,25.16 339.98,25 339.75,25 C339.519,25 339.32,25.16 339.271,25.385 L338.699,28.016 C334.645,28.495 331.495,31.645 331.016,35.699 L328.385,36.271 C328.16,36.32 328,36.519 328,36.749 C328,36.98 328.16,37.179 328.385,37.228 L331.016,37.8 C331.496,41.855 334.645,45.004 338.699,45.483 L339.271,48.114 C339.32,48.339 339.519,48.499 339.75,48.499 C339.98,48.499 340.179,48.339 340.228,48.114 L340.8,45.483 C344.854,45.004 348.004,41.855 348.483,37.8 L351.114,37.228 C351.339,37.179 351.5,36.98 351.5,36.749 C351.5,36.519 351.339,36.32 351.114,36.271 Z'
        fill={color}
      />
    </g>
  </svg>
);

export const DashboardIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
  <svg
    width='26px'
    height='13px'
    viewBox='0 0 26 13'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-185.000000, -30.000000)'>
      <g
        transform='translate(185.000000, 29.131900)'
        fill={color}>
        <path d='M22.8817,5.181 C22.0027,5.181 21.2877,4.465 21.2877,3.586 C21.2877,2.707 22.0027,1.992 22.8817,1.992 C23.7607,1.992 24.4767,2.706 24.4767,3.586 C24.4767,4.465 23.7607,5.181 22.8817,5.181 M16.1867,11.876 C15.3067,11.876 14.5917,11.161 14.5917,10.282 C14.5917,9.403 15.3067,8.687 16.1867,8.687 C17.0657,8.687 17.7807,9.403 17.7807,10.282 C17.7807,11.161 17.0657,11.876 16.1867,11.876 M7.8187,3.586 C7.8187,2.707 8.5347,1.992 9.4137,1.992 C10.2937,1.992 11.0087,2.706 11.0087,3.586 C11.0087,4.465 10.2937,5.181 9.4137,5.181 C8.5347,5.181 7.8187,4.465 7.8187,3.586 M2.7177,11.876 C1.8387,11.876 1.1237,11.161 1.1237,10.282 C1.1237,9.403 1.8387,8.687 2.7177,8.687 C3.5977,8.687 4.3127,9.403 4.3127,10.282 C4.3127,11.161 3.5977,11.876 2.7177,11.876 M22.8817,0.869 C21.3827,0.869 20.1637,2.087 20.1637,3.586 C20.1637,4.133 20.3267,4.642 20.6057,5.069 L17.6687,8.005 C17.2417,7.727 16.7327,7.564 16.1867,7.564 C15.6197,7.564 15.0927,7.738 14.6577,8.035 L11.6907,5.069 C11.9687,4.642 12.1317,4.133 12.1317,3.586 C12.1317,2.087 10.9127,0.869 9.4137,0.869 C7.9147,0.869 6.6957,2.087 6.6957,3.586 C6.6957,4.133 6.8587,4.642 7.1367,5.069 L4.1997,8.005 C3.7737,7.726 3.2647,7.564 2.7177,7.564 C1.2197,7.564 -0.0003,8.783 -0.0003,10.282 C-0.0003,11.781 1.2197,13 2.7177,13 C4.2167,13 5.4367,11.781 5.4367,10.282 C5.4367,9.735 5.2737,9.226 4.9947,8.799 L7.9317,5.863 C8.3587,6.142 8.8667,6.304 9.4137,6.304 C9.9607,6.304 10.4697,6.142 10.8967,5.863 L13.8797,8.846 C13.6187,9.263 13.4677,9.755 13.4677,10.282 C13.4677,11.781 14.6877,13 16.1867,13 C17.6847,13 18.9047,11.781 18.9047,10.282 C18.9047,9.735 18.7417,9.226 18.4637,8.799 L21.3997,5.863 C21.8267,6.142 22.3357,6.304 22.8817,6.304 C24.3807,6.304 25.5997,5.085 25.5997,3.586 C25.5997,2.087 24.3807,0.869 22.8817,0.869' />
      </g>
    </g>
  </svg>
);

// export const TrustarIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
//   <img
//     src={color === 'white' ? logoSrc : logoSrcBlue}
//     alt='trustar logo' />
// );
export const TrustarAdminIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
  <img
    style={{width: '10rem'}}
    src={adminAddonBonus}
    alt='admin mode' />
);

export const SaveIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
  <svg
    width='19px'
    height='19px'
    viewBox='0 0 19 19'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-1144.000000, -86.000000)'>
      <path
        d='M1161.235,102.698 C1161.235,102.994 1160.994,103.235 1160.699,103.235 L1159.089,103.235 L1159.089,96.262 C1159.089,95.375 1158.368,94.653 1157.481,94.653 L1148.827,94.653 C1147.94,94.653 1147.218,95.375 1147.218,96.262 L1147.218,103.235 L1145.609,103.235 C1145.313,103.235 1145.072,102.994 1145.072,102.698 L1145.072,87.609 C1145.072,87.313 1145.313,87.072 1145.609,87.072 L1148.291,87.072 L1148.291,90.827 C1148.291,91.715 1149.013,92.436 1149.9,92.436 L1156.408,92.436 C1157.295,92.436 1158.017,91.715 1158.017,90.827 L1158.017,87.072 L1158.109,87.072 C1158.252,87.072 1158.387,87.128 1158.488,87.229 L1161.078,89.819 C1161.179,89.921 1161.235,90.055 1161.235,90.199 L1161.235,102.698 Z M1158.017,96.799 L1148.291,96.799 L1148.291,96.262 C1148.291,95.967 1148.531,95.725 1148.827,95.725 L1157.481,95.725 C1157.776,95.725 1158.017,95.967 1158.017,96.262 L1158.017,96.799 Z M1148.291,103.235 L1158.017,103.235 L1158.017,97.871 L1148.291,97.871 L1148.291,103.235 Z M1149.363,87.072 L1154.798,87.072 L1154.798,89.755 C1154.798,90.051 1155.039,90.291 1155.335,90.291 C1155.631,90.291 1155.871,90.051 1155.871,89.755 L1155.871,87.072 L1156.944,87.072 L1156.944,90.827 C1156.944,91.123 1156.703,91.363 1156.408,91.363 L1149.9,91.363 C1149.604,91.363 1149.363,91.123 1149.363,90.827 L1149.363,87.072 Z M1161.837,89.06 L1159.247,86.47 C1158.943,86.167 1158.539,86 1158.109,86 L1148.827,86 L1145.609,86 C1144.722,86 1144,86.721 1144,87.609 L1144,102.698 C1144,103.586 1144.722,104.307 1145.609,104.307 L1160.699,104.307 C1161.586,104.307 1162.308,103.586 1162.308,102.698 L1162.308,90.199 C1162.308,89.768 1162.14,89.365 1161.837,89.06 Z'
        fill={color}
      />
    </g>
  </svg>
);

export const ExportIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
  <svg
    className={cx('icon')}
    width='17px'
    height='20px'
    viewBox='0 0 17 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-1221.000000, -87.000000)'>
      <g transform='translate(1222.000000, 87.000000)'>
        <path d='M14.2556,19.3705 L1.7326,19.3705 C0.9426,19.3705 0.2996,18.7285 0.2996,17.9385 L0.2996,1.7315 C0.2996,0.9415 0.9426,0.3005 1.7326,0.3005 L10.8266,0.3005 C10.9846,0.3005 11.1126,0.4285 11.1126,0.5865 C11.1126,0.7445 10.9846,0.8725 10.8266,0.8725 L1.7326,0.8725 C1.2586,0.8725 0.8726,1.2585 0.8726,1.7315 L0.8726,17.9385 C0.8726,18.4125 1.2586,18.7985 1.7326,18.7985 L14.2556,18.7985 C14.7296,18.7985 15.1146,18.4125 15.1146,17.9385 L15.1146,5.2855 C15.1146,5.1275 15.2426,4.9995 15.4016,4.9995 C15.5596,4.9995 15.6876,5.1275 15.6876,5.2855 L15.6876,17.9385 C15.6876,18.7285 15.0456,19.3705 14.2556,19.3705' />
        <path
          d='M14.2556,19.3705 L1.7326,19.3705 C0.9426,19.3705 0.2996,18.7285 0.2996,17.9385 L0.2996,1.7315 C0.2996,0.9415 0.9426,0.3005 1.7326,0.3005 L10.8266,0.3005 C10.9846,0.3005 11.1126,0.4285 11.1126,0.5865 C11.1126,0.7445 10.9846,0.8725 10.8266,0.8725 L1.7326,0.8725 C1.2586,0.8725 0.8726,1.2585 0.8726,1.7315 L0.8726,17.9385 C0.8726,18.4125 1.2586,18.7985 1.7326,18.7985 L14.2556,18.7985 C14.7296,18.7985 15.1146,18.4125 15.1146,17.9385 L15.1146,5.2855 C15.1146,5.1275 15.2426,4.9995 15.4016,4.9995 C15.5596,4.9995 15.6876,5.1275 15.6876,5.2855 L15.6876,17.9385 C15.6876,18.7285 15.0456,19.3705 14.2556,19.3705 Z'
          stroke={color}
          strokeWidth='0.6'
        />
        <path d='M15.4011,5.5726 L10.8271,5.5726 C10.6691,5.5726 10.5401,5.4436 10.5401,5.2856 L10.5401,0.7106 C10.5401,0.5516 10.6691,0.4246 10.8271,0.4246 C10.9841,0.4246 11.1131,0.5516 11.1131,0.7106 L11.1131,4.9986 L15.4011,4.9986 C15.5591,4.9986 15.6881,5.1276 15.6881,5.2856 C15.6881,5.4436 15.5601,5.5726 15.4011,5.5726' />
        <path
          d='M15.4011,5.5726 L10.8271,5.5726 C10.6691,5.5726 10.5401,5.4436 10.5401,5.2856 L10.5401,0.7106 C10.5401,0.5516 10.6691,0.4246 10.8271,0.4246 C10.9841,0.4246 11.1131,0.5516 11.1131,0.7106 L11.1131,4.9986 L15.4011,4.9986 C15.5591,4.9986 15.6881,5.1276 15.6881,5.2856 C15.6881,5.4436 15.5601,5.5726 15.4011,5.5726 Z'
          stroke={color}
          strokeWidth='0.6'
        />
        <path d='M15.4011,5.5726 C15.3271,5.5726 15.2521,5.5436 15.1961,5.4856 L10.6221,0.7866 C10.5111,0.6746 10.5141,0.4916 10.6271,0.3826 C10.7401,0.2706 10.9221,0.2736 11.0321,0.3876 L15.6071,5.0866 C15.7161,5.1996 15.7141,5.3816 15.6011,5.4916 C15.5461,5.5456 15.4731,5.5726 15.4011,5.5726' />
        <path
          d='M15.4011,5.5726 C15.3271,5.5726 15.2521,5.5436 15.1961,5.4856 L10.6221,0.7866 C10.5111,0.6746 10.5141,0.4916 10.6271,0.3826 C10.7401,0.2706 10.9221,0.2736 11.0321,0.3876 L15.6071,5.0866 C15.7161,5.1996 15.7141,5.3816 15.6011,5.4916 C15.5461,5.5456 15.4731,5.5726 15.4011,5.5726 Z'
          stroke={color}
          strokeWidth='0.6'
        />
        <polyline
          stroke={color}
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
          points='3.6062 11.3178 7.9942 15.7058 12.3812 11.3178'
        />
        <path
          d='M7.9939,8.8529 L7.9939,15.1679'
          stroke={color}
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </g>
  </svg>
);

export const RefreshIcon = () => (
  <img
    className={cx('icon')} src={reloadIcon}
    alt='Refresh Icon' />
);

export const NextIcon = () => (
  <img
    className={cx('icon')} src={nextIcon}
    alt='Next Icon' />
);

export const PrevIcon = () => (
  <img
    className={cx('icon')} src={prevIcon}
    alt='Prev Icon' />
);

export const SearchIcon = () => (
  <img
    className={cx('icon')} src={searchIcon}
    alt='Search Icon' />
);

export const FilterIcon = () => (
  <img
    className={cx('icon')} src={filterIcon}
    alt='Filter Icon' />
);

export const CalendarIcon = () => (
  <img
    className={cx('icon')} src={calendarIcon}
    alt='Calendar Icon' />
);

export const FloppyIcon = () => (
  <img
    className={cx('icon')} src={floppyIcon}
    alt='Floppy Icon' />
);

export const DownloadIcon = () => (
  <img
    className={cx('icon')} src={downloadIcon}
    alt='Download Icon' />
);

export const CogIcon = () => (
  <img
    className={cx('icon')} src={cogIcon}
    alt='Cog Icon' />
);

export const RedoIcon = () => (
  <img
    className={cx('icon')} src={redoIcon}
    alt='Redo Icon' />
);

export const UndoIcon = () => (
  <img
    className={cx('icon')} src={undoIcon}
    alt='Undo Icon' />
);

export const InboxDownloadIcon = () => (
  <svg
    width='20px'
    height='19px'
    viewBox='0 0 20 19'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g
      id='Page-1'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'>
      <g
        id='Add-More-Enclaves-Filter'
        transform='translate(-257.000000, -104.000000)'>
        <g
          id='Group'
          transform='translate(257.000000, 104.000000)'>
          <g
            id='if_icon-92-inbox-download_314776'
            transform='translate(0.000000, 4.800000)'
            fill='#44546A'
            fillRule='nonzero'>
            <path
              d='M13.6,6.4 L19.0200195,6.4 L15.5200195,0.8 L11.2,0.8 L11.2,0 L16,0 L20,6.4 L20,7.2 L20,13.6 L0,13.6 L0,6.4 L4,0 L8.8,0 L8.8,0.8 L4.47998047,0.8 L0.979980472,6.4 L6.4,6.4 L6.4,8 C6.4,8.8836556 7.11668624,9.6 7.99791336,9.6 L12.0020866,9.6 C12.8845898,9.6 13.6,8.88981632 13.6,8 L13.6,6.4 Z'
              id='inbox-download'></path>
          </g>
          <rect
            id='Rectangle-3'
            fill='#FFFFFF'
            x='5.6'
            y='4.8'
            width='8.8'
            height='1'></rect>
          <g
            id='cog'
            transform='translate(6.400000, 0.000000)'
            fill='#44546A'
            fillRule='nonzero'>
            <path
              d='M3.0524,7.8808 C3.036,7.8808 3.0192,7.8788 3.0024,7.8744 C2.6432,7.782 2.298,7.6396 1.9768,7.4508 C1.8836,7.396 1.8508,7.2772 1.9024,7.1824 C1.966,7.0656 1.9996,6.9336 1.9996,6.7996 C1.9996,6.3584 1.6408,5.9996 1.1996,5.9996 C1.066,5.9996 0.9336,6.0332 0.8168,6.0968 C0.722,6.1484 0.6032,6.1156 0.5484,6.0224 C0.3596,5.7008 0.2172,5.356 0.1248,4.9968 C0.0988,4.8952 0.1556,4.7908 0.2548,4.7576 C0.5804,4.648 0.7996,4.3432 0.7996,3.9996 C0.7996,3.656 0.5808,3.3512 0.2548,3.2416 C0.1556,3.208 0.0988,3.104 0.1248,3.0024 C0.2172,2.6432 0.3596,2.298 0.5484,1.9768 C0.6032,1.8836 0.722,1.8508 0.8168,1.9024 C0.9332,1.966 1.0656,1.9996 1.1996,1.9996 C1.6408,1.9996 1.9996,1.6408 1.9996,1.1996 C1.9996,1.066 1.966,0.9336 1.9024,0.8168 C1.8508,0.722 1.8836,0.6032 1.9768,0.5484 C2.2984,0.3596 2.6432,0.2172 3.0024,0.1248 C3.104,0.0988 3.2084,0.1556 3.2416,0.2548 C3.3512,0.5804 3.656,0.7996 3.9996,0.7996 C4.3432,0.7996 4.648,0.5808 4.7576,0.2548 C4.7912,0.1556 4.8956,0.0988 4.9968,0.1248 C5.356,0.2172 5.7012,0.3596 6.0224,0.5484 C6.1156,0.6032 6.1484,0.722 6.0968,0.8168 C6.0332,0.9336 5.9996,1.0656 5.9996,1.1996 C5.9996,1.6408 6.3584,1.9996 6.7996,1.9996 C6.9332,1.9996 7.0656,1.966 7.1824,1.9024 C7.2772,1.8508 7.396,1.8836 7.4508,1.9768 C7.6396,2.2984 7.782,2.6432 7.8744,3.0024 C7.9004,3.104 7.8436,3.2084 7.7444,3.2416 C7.4188,3.3512 7.1996,3.656 7.1996,3.9996 C7.1996,4.3432 7.4184,4.648 7.7444,4.7576 C7.8436,4.7912 7.9004,4.8952 7.8744,4.9968 C7.782,5.356 7.6396,5.7012 7.4508,6.0224 C7.396,6.1156 7.2772,6.1484 7.1824,6.0968 C7.0656,6.0332 6.9336,5.9996 6.7996,5.9996 C6.3584,5.9996 5.9996,6.3584 5.9996,6.7996 C5.9996,6.9332 6.0332,7.0656 6.0968,7.1824 C6.1484,7.2772 6.1156,7.396 6.0224,7.4508 C5.7008,7.6396 5.356,7.782 4.9968,7.8744 C4.8952,7.9004 4.7908,7.8436 4.7576,7.7444 C4.648,7.4188 4.3432,7.1996 3.9996,7.1996 C3.656,7.1996 3.3512,7.4184 3.2416,7.7444 C3.2136,7.8272 3.136,7.8808 3.052,7.8808 L3.0524,7.8808 Z M4,6.8 C4.4508,6.8 4.8568,7.0512 5.062,7.4408 C5.27,7.3764 5.4724,7.2932 5.666,7.192 C5.6228,7.0664 5.6004,6.9336 5.6004,6.8 C5.6004,6.1384 6.1388,5.6 6.8004,5.6 C6.934,5.6 7.0668,5.6224 7.1924,5.6656 C7.2936,5.472 7.3772,5.27 7.4412,5.0616 C7.0516,4.8568 6.8004,4.4508 6.8004,3.9996 C6.8004,3.5484 7.0516,3.1428 7.4412,2.9376 C7.3768,2.7296 7.2936,2.5272 7.1924,2.3336 C7.0668,2.3768 6.934,2.3992 6.8004,2.3992 C6.1388,2.3992 5.6004,1.8608 5.6004,1.1992 C5.6004,1.0656 5.6228,0.9328 5.666,0.8072 C5.4724,0.706 5.2704,0.6224 5.062,0.5584 C4.8572,0.948 4.4512,1.1992 4,1.1992 C3.5488,1.1992 3.1432,0.948 2.938,0.5584 C2.73,0.6224 2.5276,0.706 2.334,0.8072 C2.3772,0.9328 2.3996,1.0656 2.3996,1.1992 C2.3996,1.8608 1.8612,2.3992 1.1996,2.3992 C1.066,2.3992 0.9332,2.3768 0.8076,2.3336 C0.7064,2.5272 0.6228,2.7292 0.5588,2.9376 C0.9484,3.1424 1.1996,3.5484 1.1996,3.9996 C1.1996,4.4508 0.9484,4.8564 0.5588,5.0616 C0.6228,5.2696 0.7064,5.472 0.8076,5.6656 C0.9332,5.6224 1.066,5.6 1.1996,5.6 C1.8612,5.6 2.3996,6.1384 2.3996,6.8 C2.3996,6.9336 2.3772,7.0664 2.334,7.192 C2.5276,7.2932 2.7296,7.3768 2.938,7.4408 C3.1428,7.0512 3.5488,6.8 4,6.8 Z'
              id='Shape'></path>
            <path
              d='M4,5.2 C3.3384,5.2 2.8,4.6616 2.8,4 C2.8,3.3384 3.3384,2.8 4,2.8 C4.6616,2.8 5.2,3.3384 5.2,4 C5.2,4.6616 4.6616,5.2 4,5.2 Z M4,3.2 C3.5588,3.2 3.2,3.5588 3.2,4 C3.2,4.4412 3.5588,4.8 4,4.8 C4.4412,4.8 4.8,4.4412 4.8,4 C4.8,3.5588 4.4412,3.2 4,3.2 Z'
              id='Shape'></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const CheckMark = ({className, ...props}: Object) => (
  <svg
    width='14px'
    height='10px'
    viewBox='0 0 14 10'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    className={cx('CheckMark', className)}
    {...props}>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-422.000000, -213.000000)'>
      <g transform='translate(422.000000, 213.000000)'>
        <path d='M13.1455,0.19503 C12.8845,-0.06497 12.4625,-0.06497 12.2025,0.19503 L4.2105,8.18703 L1.1385,5.11503 C0.8785,4.85403 0.4565,4.85403 0.1955,5.11503 C-0.0645,5.37603 -0.0645,5.79803 0.1955,6.05803 L3.7385,9.60203 C3.9995,9.86203 4.4215,9.86203 4.6825,9.60203 L13.1455,1.13803 C13.4055,0.87903 13.4055,0.45603 13.1455,0.19503' />
      </g>
    </g>
  </svg>
);

export const PencilIcon = ({className, ...props}: Object) => (
  <svg
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    className={className}
    {...props}>
    <defs>
      <path
        d='M21.104,2.89599995 C20.542,2.33399995 19.795,2.02499995 19,2.02499995 C18.205,2.02499995 17.458,2.33399995 16.896,2.89599995 L4.14599996,15.646 C4.09399996,15.698 4.05499996,15.76 4.02999996,15.829 L2.02999995,21.329 C1.96399995,21.512 2.00899995,21.716 2.14599995,21.853 C2.24099995,21.948 2.36899995,21.999 2.49999995,21.999 C2.55699995,21.999 2.61499995,21.989 2.67099995,21.969 L8.17099998,19.969 C8.23999998,19.944 8.30199998,19.904 8.35399998,19.853 L21.104,7.10299998 C21.666,6.54099997 21.975,5.79399997 21.975,4.99899996 C21.975,4.20399996 21.666,3.45699996 21.104,2.89499995 L21.104,2.89599995 Z M7.72499998,19.068 L3.33599996,20.664 L4.93199996,16.275 L16,5.20699997 L18.793,7.99999998 L7.72499998,19.068 Z M20.396,6.39599997 L19.5,7.29199998 L16.707,4.49899996 L17.603,3.60299996 C17.976,3.22999996 18.472,3.02499996 18.999,3.02499996 C19.526,3.02499996 20.022,3.22999996 20.395,3.60299996 C20.768,3.97599996 20.973,4.47199996 20.973,4.99899996 C20.973,5.52599997 20.768,6.02199997 20.395,6.39499997 L20.396,6.39599997 Z'
        id='path-1'></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'>
      <g
        id='0014-pencil'
        transform='translate(-2.000000, -2.000000)'>
        <mask
          id='mask-2'
          fill='white'>
          <use xlinkHref='#path-1'></use>
        </mask>
        <use
          fill='#000000'
          fillRule='nonzero'
          xlinkHref='#path-1'></use>
      </g>
    </g>
  </svg>
);

export const TrashIcon = ({className, ...props}: Object) => (
  <svg
    width='20px'
    height='20px'
    viewBox='0 0 15 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    className={className}
    {...props}>
    <title>trash2</title>
    <defs>
      <path
        d='M17.5,3.99999996 L14,3.99999996 L14,3.49999996 C14,2.67299995 13.327,1.99999995 12.5,1.99999995 L10.5,1.99999995 C9.67299999,1.99999995 8.99999998,2.67299995 8.99999998,3.49999996 L8.99999998,3.99999996 L5.49999997,3.99999996 C4.67299996,3.99999996 3.99999996,4.67299996 3.99999996,5.49999997 L3.99999996,6.49999997 C3.99999996,7.15199998 4.41799996,7.70799998 4.99999996,7.91399998 L4.99999996,20.5 C4.99999996,21.327 5.67299997,22.0000001 6.49999997,22.0000001 L16.5,22.0000001 C17.327,22.0000001 18,21.327 18,20.5 L18,7.91399998 C18.582,7.70799998 19,7.15199998 19,6.49999997 L19,5.49999997 C19,4.67299996 18.327,3.99999996 17.5,3.99999996 Z M9.99999999,3.49999996 C9.99999999,3.22399996 10.224,2.99999995 10.5,2.99999995 L12.5,2.99999995 C12.776,2.99999995 13,3.22399996 13,3.49999996 L13,3.99999996 L9.99999999,3.99999996 L9.99999999,3.49999996 Z M16.5,21 L6.49999997,21 C6.22399997,21 5.99999997,20.776 5.99999997,20.5 L5.99999997,7.99999998 L17,7.99999998 L17,20.5 C17,20.776 16.776,21 16.5,21 Z M18,6.49999997 C18,6.77599997 17.776,6.99999997 17.5,6.99999997 L5.49999997,6.99999997 C5.22399997,6.99999997 4.99999996,6.77599997 4.99999996,6.49999997 L4.99999996,5.49999997 C4.99999996,5.22399997 5.22399997,4.99999996 5.49999997,4.99999996 L17.5,4.99999996 C17.776,4.99999996 18,5.22399997 18,5.49999997 L18,6.49999997 Z M14.5,8.99999999 C14.224,8.99999999 14,9.22399999 14,9.49999999 L14,19.5 C14,19.776 14.224,20 14.5,20 C14.776,20 15,19.776 15,19.5 L15,9.49999999 C15,9.22399999 14.776,8.99999999 14.5,8.99999999 Z M11.5,8.99999999 C11.224,8.99999999 11,9.22399999 11,9.49999999 L11,19.5 C11,19.776 11.224,20 11.5,20 C11.776,20 12,19.776 12,19.5 L12,9.49999999 C12,9.22399999 11.776,8.99999999 11.5,8.99999999 Z M8.49999998,8.99999999 C8.22399998,8.99999999 7.99999998,9.22399999 7.99999998,9.49999999 L7.99999998,19.5 C7.99999998,19.776 8.22399998,20 8.49999998,20 C8.77599998,20 8.99999998,19.776 8.99999998,19.5 L8.99999998,9.49999999 C8.99999998,9.22399999 8.77599998,8.99999999 8.49999998,8.99999999 Z'
        id='path-2'></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'>
      <g
        id='0130-trash2'
        transform='translate(-4.000000, -2.000000)'>
        <mask
          id='mask-2'
          fill='white'>
          <use xlinkHref='#path-2'></use>
        </mask>
        <use
          fill='#000000'
          fillRule='nonzero'
          xlinkHref='#path-2'></use>
      </g>
    </g>
  </svg>
);

export const PlusIcon = ({className, ...props}: Object) => (
  <svg
    width='16px'
    height='16px'
    viewBox='0 0 19 19'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    className={className}
    {...props}>
    <defs>
      <path
        d='M20.5,12 L12,12 L12,3.49999996 C12,3.22399996 11.776,2.99999995 11.5,2.99999995 C11.224,2.99999995 11,3.22399996 11,3.49999996 L11,12 L2.49999995,12 C2.22399995,12 1.99999995,12.224 1.99999995,12.5 C1.99999995,12.776 2.22399995,13 2.49999995,13 L11,13 L11,21.5 C11,21.776 11.224,22.0000001 11.5,22.0000001 C11.776,22.0000001 12,21.776 12,21.5 L12,13 L20.5,13 C20.776,13 21,12.776 21,12.5 C21,12.224 20.776,12 20.5,12 Z'
        id='path-3'></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'>
      <g
        id='0823-plus'
        transform='translate(-2.000000, -3.000000)'>
        <mask
          id='mask-2'
          fill='white'>
          <use xlinkHref='#path-3'></use>
        </mask>
        <use
          fill='#000000'
          fillRule='nonzero'
          xlinkHref='#path-3'></use>
      </g>
    </g>
  </svg>
);

export const CloseIcon = ({className, ...props}: Object) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 24 24'
    width='24px'
    height='24px'
    className={cx('CloseIcon', className)}
    {...props}>
    <defs>
      <path
        d='M12.707 12.5l5.646-5.64600003c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0L12 11.793 6.35399997 6.14699997c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707L11.293 12.5l-5.64600003 5.646c-.195.195-.195.512 0 .707.098.098.226.146.354.146.128 0 .256-.049.354-.146L12.001 13.207l5.646 5.646c.098.098.226.146.354.146.128 0 .256-.049.354-.146.195-.195.195-.512 0-.707L12.709 12.5h-.002z'
        id='a' />
    </defs>
    <g
      fill='none'
      fillRule='evenodd'
      stroke='#FFF'>
      <mask
        id='b'
        fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <g
        mask='url(#b)'
        fill='#cccccc'
        stroke='#979797'>
        <path d='M.5.5h23v23H.5z' />
      </g>
    </g>
  </svg>
);

export const MinusIcon = ({className, ...props}: Object) => (
  <svg
    width='19px'
    height='1px'
    viewBox='0 0 19 1'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    className={cx('MinusIcon', className)}
    {...props}>
    <defs>
      <path
        d='M20.5,13 L2.49999995,13 C2.22399995,13 1.99999995,12.776 1.99999995,12.5 C1.99999995,12.224 2.22399995,12 2.49999995,12 L20.5,12 C20.776,12 21,12.224 21,12.5 C21,12.776 20.776,13 20.5,13 Z'
        id='path-5'></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'>
      <g
        id='0824-minus'
        transform='translate(-2.000000, -12.000000)'>
        <mask
          id='mask-2'
          fill='white'>
          <use xlinkHref='#path-5'></use>
        </mask>
        <use
          fill='#000000'
          fillRule='nonzero'
          xlinkHref='#path-5'></use>
      </g>
    </g>
  </svg>
);

export const ImportIcon = ({className, ...props}: Object) => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width='20px'
      height='20px'
      viewBox='0 0 20 20'
      xmlSpace='preserve'
      className={cx('ImportIcon', className)}
      {...props}>
      <g transform='translate(80 2160)'>
        <path
          className='st0'
          d='M-62.2-2142h-16c-0.8,0-1.5-0.7-1.5-1.5v-2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2
		c0,0.3,0.2,0.5,0.5,0.5h16c0.3,0,0.5-0.2,0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2
		C-60.7-2142.7-61.4-2142-62.2-2142z' />
        <path
          className='st0'
          d='M-64.9-2152.4l-5-5c-0.2-0.2-0.5-0.2-0.7,0l-5,5c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0l4.1-4.1v10.3
		c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-10.3l4.1,4.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1
		C-64.7-2151.9-64.7-2152.2-64.9-2152.4z' />
      </g>
    </svg>
  );
};









// WEBPACK FOOTER //
// ./web_modules/trustar/icons/Icons.js